import React, { useEffect } from "react";
import CloudHoisting from "../components/sections/securitySection/CloudHosing";
import { HeroReuse } from "../components/common/HeroReuse";
import { dataSecurityInformationSection, SecurityAndPrivacyData } from "../constants/data";
import FeatureDisplay from "../components/common/FeatureDisplay";
import InfoSection from "../components/common/InfoSection";
import frame2 from "../assets/iso_Frame.svg";
import frame1 from "../assets/logo-fips-140-2 1.svg";
import RequestDemo from "../components/common/RequestDemo";
import { useLocation } from "react-router-dom";
import SecurityPageLottie from '../website animations/SecurityPageAnimation.json'

const SecurityPage = () => {
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.hash.substring(1);
    const section = document.getElementById(sectionId);
    if(section){      
      window.scrollTo({
        top: section.offsetTop - 175,
        behavior: "smooth"
      });
    }
  }, [location]);

  return (
    <div className="flex flex-col items-center justify-center gap-8 sm:gap-16">
      <HeroReuse
        Subtitle="SECURITY"
        // Title="How RegTechFlow keeps your data safe while making compliance easy"
        Title="At RegTechFlow, your information security and privacy are our top priorities."
        // ButtonText="Request a Demo Today"
        // descriptionhead={'RegTechFlow'}
        lottie={SecurityPageLottie}
      />
      <FeatureDisplay infoSectionData={dataSecurityInformationSection} data={SecurityAndPrivacyData} />
      <CloudHoisting />
      <div
        id="certifications" 
        className="px-4 flex justify-center items-center"
      >
        <InfoSection
          subtitle="We take compliance and security seriously"
          description="RegTechFlow ensures top-tier security with encrypted data, GDPR compliance, and flexible cloud or on-premise hosting. With secure access controls and seamless integrations, your compliance data stays protected and fully traceable."
          imageArray={[frame1, frame2]}
          width="max-w-[370px] sm:max-w-2xl"
          descriptionClass="max-w-full"
          gap="2rem"
        />
      </div>
      <RequestDemo />
    </div>
  );
};

export default SecurityPage;
